<template>
  <a-card>
    <div style="margin-bottom: 20px">
      <a-button v-permission="`settings.Sysapplicationmodule.Add`" @click="module.visible = true" icon="plus" type="primary">添加模块</a-button>
    </div>
    <a-table style="min-width: 800px" :columns="columns" row-key="id" :loading="tableRelevant.tableLoading" :locale="tableRelevant.locale" :dataSource="tableRelevant.tableDataSource">
      <div v-auth="`settings.Sysapplicationmodule.Status`" slot="enabled" slot-scope="text, record">
        <a-switch @change="tableEnabledChange(text)" v-model="text.enabled" checked-children="启用" un-checked-children="禁用" />
      </div>
      <div slot="icon" slot-scope="text, record">
        <img v-if="/\.(gif|jpg|jpeg|png|GIF|JPEG|JPG|PNG)$/.test(text.icon)" :src="text.icon | filterUrl" style="width: 18px; height: 18px; object-fit: contain" alt="" />
        <a-icon v-else :type="text.icon" />
      </div>
      <div slot="property" slot-scope="text, record">{{ ['通用', '管理机构', '子机构'][text.property] }}</div>
      <div slot="action" slot-scope="text, record">
        <a v-permission="`settings.Sysapplicationmodule.Edit`" @click="tableEdit(text)" style="margin-right: 10px">
          <a-icon type="edit" />
          编辑</a
        >
        <a v-permission="`settings.Sysapplicationmodule.Config`" @click="tableFun(text)" style="margin-right: 10px">
          <a-icon type="hdd" />
          权限</a
        >
        <a-popconfirm v-permission="`settings.Sysapplicationmodule.Delete`" title="确认要删除此模块吗？" @confirm="tableDelete(text)" ok-text="确认" cancel-text="取消">
          <a style="margin-right: 10px; color: #f5222d">
            <a-icon type="delete" />
            删除</a
          >
        </a-popconfirm>
      </div>
    </a-table>

    <!--添加编辑模块-->
    <a-modal v-model="module.visible" :centered="true" :destroyOnClose="true" :title="module.title" :confirm-loading="module.confirmLoading" @cancel="moduleCancel" @ok="moduleOk" width="800px">
      <a-form-model style="height: 450px; overflow-y: auto" ref="moduleRuleForm" :model="module.data" :rules="module.rules" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
        <a-form-model-item ref="name" label="模块名称" prop="name">
          <a-input @change="(e) => (module.data.name = e.target.value.replace(/\s*/g, ''))" v-model="module.data.name" placeholder="请输入模块名称" />
        </a-form-model-item>
        <a-form-model-item label="所属模块">
          <a-tree-select
            v-model="module.data.parentId"
            style="width: 100%"
            :replaceFields="{ title: 'name', value: 'id', key: 'id' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="tableRelevant.tableDataSource"
            placeholder="请选择所属模块"
          >
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="Icon">
          <a-input v-model="module.data.icon" placeholder="请输入icon名称或地址" />
        </a-form-model-item>
        <a-form-model-item label="显示顺序" prop="displayOrder">
          <a-input v-model="module.data.displayOrder" placeholder="请输入显示顺序" />
        </a-form-model-item>
        <a-form-model-item label="是否显示">
          <a-radio-group v-model="module.data.invisible">
            <a-radio :value="false">显示</a-radio>
            <a-radio :value="true">不显示</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="module.data.enabled">
            <a-radio :value="true">启用</a-radio>
            <a-radio :value="false">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="使用类型" v-if="$route.query.type == 3">
          <a-radio-group v-model="module.data.property">
            <a-radio :value="0">通用</a-radio>
            <a-radio :value="1">管理机构</a-radio>
            <a-radio :value="2">子机构</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="模块描述" prop="remark">
          <a-input v-model="module.data.remark" placeholder="请输入模块描述" />
        </a-form-model-item>
        <a-form-model-item label="路由名称" prop="router">
          <a-input v-model="module.data.router" placeholder="请输入路由名称" />
        </a-form-model-item>
        <a-form-model-item label="访问路径">
          <a-input v-model="module.data.path" placeholder="请输入访问路径" />
        </a-form-model-item>
        <a-form-model-item label="转跳地址">
          <a-input v-model="module.data.redirectUri" placeholder="请输入转跳地址" />
        </a-form-model-item>
        <a-form-model-item label="组件">
          <a-input v-model="module.data.component" placeholder="请输入组件名称" />
        </a-form-model-item>
        <a-form-model-item label="推荐配置" v-if="$route.query.type==3">
          <a-radio-group v-model="module.data.isRecommend">
            <a-radio :value="true">启用</a-radio>
            <a-radio :value="false">不启用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-model="sysFunction.visible" :centered="true" :destroyOnClose="true" :title="`模块权限（${sysFunction.name}）`" :footer="null" width="1000px">
      <ItemSetting :item-data="sysFunction.data"></ItemSetting>
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import $Bus from '@/pages/projectImpl/js/eventBus'
import ItemSetting from './components/ItemSetting'

const columns = [
  {
    title: '模块名称',
    dataIndex: 'name',
    key: '1',
  },
  {
    title: 'icon',
    scopedSlots: { customRender: 'icon' },
    key: '2',
  },
  {
    title: '描述',
    dataIndex: 'remark',
    key: '3',
  },
  {
    title: '跳转地址',
    dataIndex: 'path',
    key: '4',
  },
  {
    title: '使用类型',
    scopedSlots: { customRender: 'property' },
  },
  {
    title: '状态',
    scopedSlots: { customRender: 'enabled' },
    key: '5',
  },
  {
    title: '显示顺序',
    dataIndex: 'displayOrder',
    key: '6',
  },
  {
    title: '操作',
    key: '9',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'SystemModule',
  components: { ItemSetting },
  data() {
    return {
      columns,
      tableRelevant: tableRelevant.call(this),
      //功能
      sysFunction: {
        visible: false,
        name: '',
        data: {},
      },
      //添加或编辑模块
      module: {
        visible: false,
        confirmLoading: false,
        title: '添加模块',
        data: {
          clientApplicationId: this.$route.query.id,
          id: undefined,
          name: '',
          parentId: undefined,
          remark: '',
          redirectUri: '',
          icon: '',
          displayOrder: '',
          enabled: true,
          property: 0,
          path: '',
          router: '',
          component: '',
          invisible: false,
          isRecommend:false
        },
        rules: {
          name: [
            { required: true, message: '请输入模块名称', trigger: 'blur' },
            { min: 2, max: 20, message: '模块名称长度 2 到 20 个字符', trigger: 'blur' },
          ],
          displayOrder: [{ required: true, message: '请输入显示顺序', trigger: 'blur' }],
          remark: [{ required: true, message: '请输入模块描述', trigger: 'blur' }],
          path: [{ required: true, message: '请输入路由名称', trigger: 'blur' }],
        },
      },
    }
  },
  created() {
    if (this.$route.query.type != 3) {
      this.columns = columns.filter((f) => f.title !== '使用类型')
    }
    $Bus.$emit('pageHeaderTitle', this.$route.query.name + '模块配置')
    this.getPageList()
  },
  methods: {
    //获取表格列表
    getPageList() {
      function recursion(arr) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].children && arr[i].children.length) {
            recursion(arr[i].children)
          } else {
            delete arr[i].children
          }
        }
      }
      this.tableRelevant.tableLoading = true
      this.$http.treeList({ applicationId: this.$route.query.id }).then((res) => {
        this.tableRelevant.tableLoading = false
        const { data } = res.data
        recursion(data)
        this.tableRelevant.tableDataSource = data
      })
    },
    //模块配置启用禁用
    tableEnabledChange(json) {
      this.tableRelevant.tableLoading = true
      this.$http.systemModuleStatus(json).then((res) => {
        this.tableRelevant.tableLoading = false
        const { message } = res.data
        this.$message.success(message)
      })
    },
    //编辑
    tableEdit(json) {
      this.module.visible = true
      this.module.title = '编辑模块'
      for (let key in this.module.data) {
        this.module.data[key] = json[key]
      }
      this.module.data.parentId = this.module.data.parentId === 0 ? undefined : this.module.data.parentId
    },
    //功能
    tableFun(json) {
      this.sysFunction.data = json
      this.sysFunction.visible = true
      this.sysFunction.name = json.name
    },
    //删除
    tableDelete(json) {
      this.$http.deleteModule([json.id]).then((res) => {
          this.$message.success('删除成功')
          this.getPageList()
       
      })
    },
    //添加编辑确认
    moduleOk() {
      this.$refs.moduleRuleForm.validate((valid) => {
        if (valid) {
          const Ajax = this.module.title === '添加模块' ? this.$http.addModule : this.$http.updateModule
          if (!this.module.data.parentId) this.module.data.parentId = 0
          this.module.confirmLoading = true
          Ajax(this.module.data).then((res) => {
            this.module.confirmLoading = false
              this.$message.success(res.data.message)
              this.moduleCancel()
              this.getPageList()
           
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //添加编辑取消
    moduleCancel() {
      this.$refs.moduleRuleForm.resetFields()
      this.module.visible = false
      this.module.title = '添加模块'
      this.module.data = {
        clientApplicationId: this.$route.query.id,
        name: '',
        parentId: undefined,
        id: undefined,
        remark: '',
        redirectUri: '',
        icon: '',
        displayOrder: '',
        enabled: true,
        property: 0,
        path: '',
        router: '',
        component: '',
        invisible: false,
        isRecommend:false
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
